export default [
    // @todo hideWordstatIntegration временно убрана интеграция с онлайн-парсером
    // {
    //     name: '__checkbox',
    //     titleClass: 'center aligned',
    //     dataClass: 'center aligned',
    // },
    {
        name: '__slot:word',
        type: 'string',
        sortField: 'word',
        defaultSearch: true,
        useInFilter: false,
    },
    {
        name: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        sortField: 'ws',
        defaultSearch: false,
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'wsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        sortField: 'wsk',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true,
    },
    {
        name: 'superwsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        sortField: 'superwsk',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true,
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'isgeo',
        type: 'bool',
        defaultSearch: false,
        useInFilter: true,
        visible: false,
    },
    {
        name: 'isquest',
        type: 'bool',
        defaultSearch: false,
        useInFilter: true,
        visible: false,
    },
    {
        name: '__slot:keys_meta',
        dataClass: 'text-center',
        defaultSearch: false,
        useInFilter: false,
        visible: false,
    },
    {
        name: 'updated_at',
        sortField: 'updatedAt',
        type: 'dateRange',
        useInFilter: true,
        defaultSearch: false,
    }
]
